import * as polyline from '@mapbox/polyline';

export function getPolyline(coordinates) {
  let coordinates_flat = coordinates.flat(1);

  if (coordinates_flat[0].length > 2) {
    coordinates_flat = coordinates_flat.flat(1);
  }

  if (coordinates_flat[0].length > 2) {
    coordinates_flat = coordinates_flat.flat(1);
  }

  // Create a 'LngLatBounds' with both corners at the first coordinate.
  if (coordinates_flat.length == 1) {
    coordinates_flat = coordinates_flat[0];
  }

  coordinates_flat = coordinates_flat.map(function (pair) {
    return pair.reverse();
  });

  let encoded = encodeURIComponent(polyline.encode(coordinates_flat));

  return encoded;
}
